import styled from 'styled-components';
import { Table } from '@material-ui/core';

const UIDataTableFullWidth = styled(Table)`
  width: 100% !important;
`;
export default UIDataTableFullWidth;
